var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-qrcode"},[_c('vue-qr',{attrs:{"text":_vm.url,"logoSrc":require('../assets/logo-qrcode.png'),"margin":0,"size":_vm.size}}),(!_vm.hideBottom)?_c('span',{staticClass:"serialNumber-span"},[_vm._v(_vm._s(_vm.serialNumber))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }